import { useForm } from 'react-hook-form'
import { Switch } from '~/shadcn/ui/switch'
import { Spinner } from '~/shadcn/ui/spinner'
import { Form, FormField, FormItem } from '~/shadcn/ui/form/form'
import { FieldContent, FieldLabel } from '~/shadcn/ui/field'
import { useSecuritySettings } from './useSecuritySettings'
import { FormError } from '~/@mid_ui-form/form-error/FormError'
import { Button } from '~/shadcn/ui/button/button'

type FormModel = {
  isTwoFaEnabled: boolean
}

type Props = {
  initialValues: FormModel
  onSuccess: () => void
}

function SecuritySettingsForm({ initialValues, onSuccess }: Props) {
  const { setSecuritySettings, isSettingSecuritySettings, error } =
    useSecuritySettings()

  const form = useForm<FormModel>({
    defaultValues: initialValues,
  })

  const handleSubmit = (values: FormModel) => {
    setSecuritySettings(
      { isTwoFaEnabled: values.isTwoFaEnabled },
      {
        onSuccess,
      }
    )
  }

  const currentValue = form.watch('isTwoFaEnabled')

  const canSubmitForm = (() => {
    return (
      currentValue !== initialValues.isTwoFaEnabled &&
      !isSettingSecuritySettings
    )
  })()

  return (
    <div className="w-full flex flex-col gap-10 last:flex-grow">
      <Form {...form}>
        <form onSubmit={form.handleSubmit(handleSubmit)}>
          <div className="flex flex-col items-start justify-between gap-8">
            <FormField
              control={form.control}
              name="isTwoFaEnabled"
              render={({ field }) => (
                <FormItem>
                  <FieldContent className="flex flex-row-reverse md:flex-row justify-between items-center gap-4">
                    <Switch
                      id="isTwoFaEnabled"
                      checked={field.value}
                      onCheckedChange={field.onChange}
                    />
                    <FieldLabel htmlFor="isTwoFaEnabled">
                      <span className="text-base font-semibold leading-[26px]">
                        Dvojfaktorová autentifikácia pomocou SMS kódu
                      </span>
                    </FieldLabel>
                  </FieldContent>
                </FormItem>
              )}
            />

            <Button variant="accent" type="submit" disabled={!canSubmitForm}>
              Uložiť zmeny{` `}
              {isSettingSecuritySettings && <Spinner className="size-4" />}
            </Button>

            {error && <FormError error={error} />}
          </div>
        </form>
      </Form>
    </div>
  )
}

export { SecuritySettingsForm }
